/* eslint-disable max-len */
export * from './ContactPage.action';
export { default as ContactPageReducer } from './ContactPage.reducer';
export { default as ContactPageDispatcher, ContactPageDispatcher as ContactPageDispatcherClass } from './ContactPage.dispatcher';
